module.exports = __webpack_public_path__ + "media/assets/images/partner-logo/HhxTt-c39e6792e52450c68e732945d1f5a099.png";